// Un correo con FORMA de correo, sin expresión regular.
//
// Antes era `/^[^\s@]+@[^\s@]+\.[^\s@]+$/` en la pantalla de evaluación: tres clases
// repetidas que se solapan, y eso es lo que Sonar señala como riesgo de ReDoS (S5852):
// con una entrada larga y torcida el motor retrocede una y otra vez. Las mismas cuatro
// condiciones se comprueban aquí en una pasada lineal: exactamente una arroba, algo
// antes, algo después con un punto que no esté en los bordes, y ningún espacio. El
// servidor vuelve a comprobarlo (es la autoridad); esto solo evita que un 422 con
// «String should match pattern…» sea lo primero que ve el Comité.
//
// No sustituye a `revisarCorreo` de `validacion.ts`: aquella explica QUÉ arreglar
// campo a campo (el registro del caso); esta responde sí/no donde solo hace falta eso.

/** Cualquier blanco en el sentido de `\s` (espacio, tabulador, salto de línea, NBSP…). Sin cuantificador: no retrocede. */
const BLANCO = /\s/;

export function esCorreoValido(valor: string): boolean {
  const partes = valor.split('@');
  if (partes.length !== 2) return false;
  const [usuario, dominio] = partes;
  if (!usuario || !dominio) return false;
  // El punto del dominio tiene que llevar algo a cada lado: `a.b` sí; `.b`, `a.` no.
  if (!dominio.slice(1, -1).includes('.')) return false;
  return !BLANCO.test(valor);
}
